export var createUouBiMiddlewareWithBiParams = function (params, events) {
    if (params.wixCodeApi.window.viewMode === 'Editor') {
        return noop;
    }
    return createMiddleware({
        bi: UoUBiLogger(params),
        eventMap: events.eventMap,
        biParams: params,
    });
};
export var createUsersBiMiddlewareWithBiParams = function (params, events) {
    return createMiddleware({
        bi: userBiLogger(params),
        eventMap: events.eventMap,
        biParams: params,
    });
};
// @ts-expect-error
var noop = function () { return function (next) { return function (action) { return next(action); }; }; };
var createMiddleware = function (_a) {
    var bi = _a.bi, eventMap = _a.eventMap, biParams = _a.biParams;
    // @ts-expect-error
    var log = function (action, store) {
        var transformEvent = eventMap[action.type];
        if (transformEvent) {
            var biEvent = transformEvent(store.getState(), action, biParams);
            bi.log(biEvent, { endpoint: eventMap.endpoint });
        }
    };
    // @ts-expect-error
    return function (store) { return function (next) { return function (action) {
        if (action) {
            log(action, store);
        }
        return next(action);
    }; }; };
};
var UoUBiLogger = function (_a) {
    var wixCodeApi = _a.wixCodeApi, platformAPIs = _a.platformAPIs, compId = _a.compId, user = _a.user;
    var visitorId = platformAPIs.bi.visitorId || user.uid || user.aid;
    return getBiLogger(platformAPIs)
        .updateDefaults({
        comp_id: compId,
        _viewMode: wixCodeApi.window.viewMode.toLowerCase(),
        visitor_id: visitorId,
    })
        .withUoUContext({
        msid: platformAPIs.bi.metaSiteId,
        visitorId: visitorId,
        siteMemberId: user.uid || platformAPIs.bi.siteMemberId || '',
    })
        .logger();
};
var userBiLogger = function (_a) {
    var compId = _a.compId, platformAPIs = _a.platformAPIs, appParams = _a.appParams;
    return getBiLogger(platformAPIs)
        .updateDefaults({
        src: 68,
        msid: platformAPIs.bi.metaSiteId || '00000000-0000-0000-0000-000000000000',
        instance_id: appParams.instanceId,
        comp_id: compId,
    })
        .logger();
};
var getBiLogger = function (platformAPIs) {
    var logger = platformAPIs.biLoggerFactory();
    return logger.factory ? logger.factory() : logger;
};
//# sourceMappingURL=ooi-bi-logger.js.map